import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

const initialState = {
  responses: {
    email: "",
    userId: `${uuidv4()}`,
    responses: [], 
  },
};
export const responseSlice = createSlice({
  name: "formResponses",
  initialState,
  reducers: {
    initializeForm: (state, action) => {
      state.responses.formId = action.payload.formId;
      state.responses.userId = action.payload.userId; // Initialize with user id
      state.responses.responses = action.payload.responses || []; // Initialize with empty or pre-defined responses
    },
    updateLocation: (state, action) => {
      const { value, name, questionId, type } = action.payload;
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        const existingAnswerIndex = state.responses.responses[
          existingResponseIndex
        ].answer.findIndex((ans) => ans.name === name);
        if (existingAnswerIndex !== -1) {
          state.responses.responses[existingResponseIndex].answer[
            existingAnswerIndex
          ].value = value;
        } else {
          state.responses.responses[existingResponseIndex].answer.push({
            value: value,
            name: name,
            type: type,
          });
        }
      } else {
        state.responses.responses.push({
          questionId,
          answer: [{ value: value, name: name, type: type }],
        });
      }
    },
    updateResponse: (state, action) => {
      const { questionId, value } = action.payload;

      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = value;
      } else {
        state.responses.responses.push({
          questionId,
          answer: value,
        });
      }
    },
    multipleChoiceResponse: (state, action) => {
      const { questionId, value } = action.payload;
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );

      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = value;
      } else {
        state.responses.responses.push({
          questionId,
          answer: value,
        });
      }
    },
    multipleChoiceResponses: (state, action) => {
      const { questionId, value, rowText, rowId } = action.payload;
      // Find or create the question entry
      const questionResponse = state.responses.responses.find(
        (response) => response.questionId === questionId
      );

      if (questionResponse) {
        // Update existing row in the answer array
        const rowResponse = questionResponse.answer.find(
          (ans) => ans.rowId === rowId
        );
        if (rowResponse) {
          rowResponse.value = value; // Update the row's value
        } else {
          questionResponse.answer.push({ rowText, value, rowId }); // Add new row response
        }
      } else {
        // If question does not exist, add it with the row response
        state.responses.responses.push({
          questionId,
          answer: [{ rowText, value, rowId }],
        });
      }
    },
    checkBoxResponse: (state, action) => {
      const { questionId, value, checked } = action.payload;
      console.log(action.payload);
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        if (checked) {
          state.responses.responses[existingResponseIndex].answer.push(value); // Add new value to the answer array
        } else {
          const optiondx =
            state.responses.responses[existingResponseIndex].answer.indexOf(
              value
            );
          state.responses.responses[existingResponseIndex].answer.splice(
            optiondx,
            1
          ); // Remove the value from the answer array
        }
      } else state.responses.responses.push({ questionId, answer: [value] });
    },

    updateCheckBoxResponses: (state, action) => {
      const { questionId, rowText, columnText, rowId, isChecked, columnId } =
        action.payload;

      console.log(action.payload);
      // Find or create the question entry
      const questionResponse = state.responses.responses.find(
        (response) => response.questionId === questionId
      );
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );

      if (existingResponseIndex !== -1) {
        const rowResponse = questionResponse.answer.find(
          (ans) => ans.rowId === rowId
        );
        if (rowResponse) {
          if (isChecked) {
            // Add the column if checked and not already present
            if (!rowResponse.values.includes(columnText)) {
              rowResponse.values.push(columnText);
            } else {
              // Remove the column if unchecked
              rowResponse.values = rowResponse.values.filter(
                (col) => col !== columnText
              );
            }
          } else {
            // Add a new row entry if it doesn't exist
            questionResponse.answer.push({
              rowText,
              values: isChecked ? [columnText] : [],
              rowId,
              columnId,
            });
          }
        } else {
          state.responses.responses[existingResponseIndex].answer.push({
            rowText,
            values: isChecked ? [columnText] : [],
            rowId,
            columnId,
          });
        }
      } else {
        state.responses.responses.push({
          questionId,
          answer: [{ rowText, values: [columnText], rowId, columnId }],
        });
      }

      // if (questionResponse) {
      //   // Find or create the row entry
      //   const rowResponse = questionResponse.answer.find(
      //     (ans) => ans.rowId === rowId
      //   );

      //   if (rowResponse) {
      //     if (isChecked) {
      //       // Add the column if checked and not already present
      //       if (!rowResponse.values.includes(columnId)) {
      //         rowResponse.values.push(columnId);
      //       }
      //     } else {
      //       // Remove the column if unchecked
      //       rowResponse.values = rowResponse.values.filter(
      //         (col) => col !== columnId
      //       );
      //     }
      //   } else {
      //     // Add a new row entry if it doesn't exist
      //     questionResponse.answer.push({
      //       rowId,
      //       values: isChecked ? [columnId] : [],
      //     });
      //   }
      // } else {
      //   // If question does not exist, add it with the row response
      //   state.responses.responses.push({
      //     questionId,
      //     answer: [{ rowId, values: isChecked ? [columnId] : [] }],
      //   });
      // }
    },

    updateEmailResponse: (state, action) => {
      const { questionId, value } = action.payload;
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = value;
      } else {
        state.responses.responses.push({
          questionId,
          answer: value,
        });
      }
    },
    updateNumber: (state, action) => {
      const { questionId, value } = action.payload;
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = value;
      } else {
        state.responses.responses.push({
          questionId,
          answer: value,
        });
      }
    },
    lineScaleResponse: (state, action) => {
      const { questionId, value } = action.payload;

      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        const existingValue =
          state.responses.responses[existingResponseIndex].answer;
        if (existingValue === value) {
          // If the same value is selected again, remove it
          state.responses.responses.splice(existingResponseIndex, 1);
        } else {
          // Otherwise, update with the new value
          state.responses.responses[existingResponseIndex].answer = value;
        }
      } else {
        state.responses.responses.push({
          questionId,
          answer: value,
        });
      }
    },
    dateUpdateResponse: (state, action) => {
      const { questionId, value } = action.payload;
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = value;
      } else {
        state.responses.responses.push({
          questionId,
          answer: value,
        });
      }
    },
    websiteResponse: (state, action) => {
      const { questionId, value } = action.payload;
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = value;
      } else {
        state.responses.responses.push({
          questionId,
          answer: value,
        });
      }
    },
    signatureResponse: (state, action) => {
      const { questionId, value } = action.payload;
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = value;
      } else {
        state.responses.responses.push({
          questionId,
          answer: value,
        });
      }
    },
    audioAVideoResponse: (state, action) => {
      const { questionId, value } = action.payload;
      console.log(action.payload);
      // const existingResponseIndex = state.responses.responses.findIndex(
      //   (response) => response.questionId === questionId
      // );
      // if (existingResponseIndex !== -1) {
      //   state.responses.responses[existingResponseIndex].answer = value;
      // } else {
      //   state.responses.responses.push({
      //     questionId,
      //     answer: value,
      //   });
      // }
    },

    dropDownResponses: (state, action) => {
      const { questionId, value } = action.payload;
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = value;
      } else {
        state.responses.responses.push({
          questionId,
          answer: value,
        });
      }
    },
    phoneResponses: (state, action) => {
      const { questionId, value } = action.payload;
      console.log(action.payload);
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = value;
      } else {
        state.responses.responses.push({
          questionId,
          answer: value,
        });
      }
    },
    nameResponses: (state, action) => {
      const { questionId, answer } = action.payload;
      console.log(action.payload);
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = answer;
      } else {
        state.responses.responses.push({
          questionId,
          answer,
        });
      }
    },
    dateTimeResponses: (state, action) => {
      const { questionId, date, time } = action.payload;
      console.log(action.payload);
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = {
          date,
          time,
        };
      } else {
        state.responses.responses.push({
          questionId,
          answer: { date, time },
        });
      }
    },
    spinnerResponse: (state, action) => {
      const { questionId, value, type } = action.payload;
      console.log(action.payload);
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = value;
        if (type === "input") {
        }
        if (type === "") {
        }
        state.responses.responses[existingResponseIndex].answer = value;
      } else {
        state.responses.responses.push({
          questionId,
          answer: value,
        });
      }
    },
    updateFiles(state, action) {
      const { questionId, files } = action.payload;
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      if (existingResponseIndex !== -1) {
        state.responses.responses[existingResponseIndex].answer = files;
      } else {
        state.responses.responses.push({
          questionId,
          answer: files,
          type: "file",
        });
      }
    },
    deleteFile(state, action) {
      const { questionId, fileIndex } = action.payload;
      const existingResponseIndex = state.responses.responses.findIndex(
        (response) => response.questionId === questionId
      );
      state.responses.responses[existingResponseIndex].answer.splice(
        fileIndex,
        1
      );
    },
  },
});

export const {
  updateFiles,
  deleteFile,
  initializeForm,
  multipleChoiceResponse,
  websiteResponse,
  phoneResponses,
  updateResponse,
  signatureResponse,
  updateCheckBoxResponses,
  multipleChoiceResponses,
  updateMultipleChoiceGridResponse,
  updateEmailResponse,
  updateNumber,
  lineScaleResponse,
  dateUpdateResponse,
  checkBoxResponse,
  audioAVideoResponse,
  dropDownResponses,
  nameResponses,
  dateTimeResponses,
  spinnerResponse,
  updateLocation,
} = responseSlice.actions;
export default responseSlice.reducer;
